export const themeOverrides = {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        body {
          background: #000000;
        }
        #root {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          height: 100%;
          min-height: 100%;
          overflow-x: hidden;
          user-select: none;
          width: 100%;
        }
        .savanna-body--desktop > #root {
          min-height: 720px;
          min-width: 1180px;
          overflow-y: hidden;
          position: relative;
        }
        .savanna-body--mobile > #root {
          background-position-x: right;
          background-position-y: center;
          background-repeat: no-repeat;
          background-size: cover;
          background-image: url(${require(`../main/mobile/img/background.jpg`)});
        }
        .savanna-body--desktop .game-modal-portal-live .ReactModal__Content {
          background: #424242;
        }
        .savanna-body--mobile .live-lobby__category-button {
          color: #5d3307; 
          font-weight: bold;
        }
        .savanna-body--mobile .live-lobby__category-button > svg {
          fill: #5d3307;
        }
        #main-content.main-content_cenered > div.gamelist-container {
          left: 13%;
        }
        #main-content.main-content_cenered > div.extras {
          left: 50%;
          transform: translateX(-50%);
          width: 75%;
        }
        #main-content.main-content_cenered > div.extras > div {
          margin-left: 0;
          margin-right: 0;
        }
        .gamelist__no-games-label {
          color: #0c410be3;
          font-size: 24px;
          font-weight: bold;
          margin-top: 4em;
          text-align: center;
        }
        .gamelist__bottom-gap {
          height: 60px!important;
        }
        .user-block {
          background: linear-gradient(180deg, #ffffffd6, #ffffff54);
          border-radius: 4px;
          color: #000000b3;
          padding-left: 4px;
          padding-right: 4px;
        }
        .user-block__value {
          font-weight: bold;
        }
      `,
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "rgb(0 0 0)"
        }
      }
    },
  },
  typography: {
    muted: {
      opacity: '.6',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#fdce07',
    },
    secondary: {
      main: '#cacaca',
    },
    toolbar: {
      main: '#ffffff',
    }
  },
}
